import { Reducer } from "redux";

import { NonCoveredServicesResponse } from "../models/Api/Master";
import { NonCoveredServicesDispatchTypes } from "../models/DispatchTypes/Master";
import { NonCoveredServicesActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: NonCoveredServicesResponse = {
  loading: false,
  response: [],
};

const NonCoveredService: Reducer<
  NonCoveredServicesResponse,
  NonCoveredServicesDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS: {
      setLocalStorageData(
        NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default NonCoveredService;
